import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Dashboard from "./pages/Dashboard/Dashboard";
import DashboardMainPage from "./components/DashboardMainPage/Dashboard_mainPage";
import Login from "./pages/Login/Login";
import Signup from "./components/Signup/Signup";
import SignupPage2 from "./pages/SignupPages/SignupPage2";
import SignupPage4 from "./pages/SignupPages/SignupPage4";
import SignupPage5 from "./pages/SignupPages/SignupPage5";
import SignupPage6New from "./pages/SignupPages/SignupPage6New";
import SignupPage7 from "./pages/SignupPages/SignupPage7";
import SignupPage9 from "./pages/SignupPages/SignupPage9";
import SignupPage10 from "./pages/SignupPages/SignupPage10";
import SignupPage10New from "./pages/SignupPages/SignupPage10New";
import SignupPage11 from "./pages/SignupPages/SignupPage11";
import SignupPage13 from "./pages/SignupPages/SignupPage13";
import SignupPage14 from "./pages/SignupPages/SignupPage14";
import SignupPage15 from "./pages/SignupPages/SignupPage15";
import SignupPage16 from "./pages/SignupPages/SignupPage16";
import SignupPage17 from "./pages/SignupPages/SignupPage17";
import SignupPage18New from "./pages/SignupPages/SignupPage18New";
import SignupPage19 from "./pages/SignupPages/SignupPage19";
import SignupPage22 from "./pages/SignupPages/SignupPage22";
import SignupPage23 from "./pages/SignupPages/SignupPage23";

import SignupPage24 from "./pages/SignupPages/SignupPage24";
import SignupPage25 from "./pages/SignupPages/SignupPage25";
import SignupPage26 from "./pages/SignupPages/SignupPage26";

import InvalidAge from "./pages/SignupPages/InvalidAge";
import DisqualifiedPage from "./pages/SignupPages/DisqualifiedPage";
import { QuizProvider } from "./pages/SignupPages/QuizContext";
import SupplementCheckout from "./pages/SupplementCheckout/SupplementCheckout";
import ThankYouPage from "./pages/SignupPages/ThankYouPage";
import NotFound from "./components/NotFound/NotFound";
import { v4 as uuidv4 } from "uuid";
import "./App.css";
import NadPlusPage from "./pages/NadPlusPages/NadplusPage";
import NadPlusPage1 from "./pages/NadPlusPages/NadPlusPage1";
import NadPlusPage2 from "./pages/NadPlusPages/NadPlusPage2";
import NadPlusPage3 from "./pages/NadPlusPages/NadPlusPage3";
import NadPlusPage4 from "./pages/NadPlusPages/NadPlusPage4";
import NadPlusPage5 from "./pages/NadPlusPages/NadPlusPage5";
import NadPlusPage6 from "./pages/NadPlusPages/NadPlusPage6";
import NadPlusPage7 from "./pages/NadPlusPages/NadPlusPage7";
import NadPlusPage8 from "./pages/NadPlusPages/NadPlusPage8";
import NadPlusPage9 from "./pages/NadPlusPages/NadPlusPage9";
import NadPlusPage10 from "./pages/NadPlusPages/NadPlusPage10";
import NadPlusPage11 from "./pages/NadPlusPages/NadPlusPage11";
import NadPlusPage12 from "./pages/NadPlusPages/NadPlusPage12";
import NadPlusPage13 from "./pages/NadPlusPages/NadplusPage13";
import DisqualifyNadPlusPage from "./pages/NadPlusPages/DisqualifyNadPlusPage";
import NadPlusThankYouPage from "./pages/NadPlusPages/NadplusThankYouPage";
import SermorelinPage from "./pages/Sermorelin/SermorelinPage";
import SermorelinPage8 from "./pages/Sermorelin/SermorelinPage8";
import SermorelinPage9 from "./pages/Sermorelin/SermorelinPage9";
import SermorelinPage10 from "./pages/Sermorelin/SermorelinPage10";
import SermorelinPage14 from "./pages/Sermorelin/SermorelinPage14";

import NewSignupPage1 from "./pages/NewSignupPages/NewSignupPage1";
import NewSignupPage2 from "./pages/NewSignupPages/NewSignupPage2";
import NewSignupPage3 from "./pages/NewSignupPages/NewSignupPage3";
import NewSignupPage4 from "./pages/NewSignupPages/NewSignupPage4";
import NewSignupPage5 from "./pages/NewSignupPages/NewSignupPage5";
import NewSignupPage6 from "./pages/NewSignupPages/NewSignupPage6";
import NewSignupPage7 from "./pages/NewSignupPages/NewSignupPage7";
import NewSignupPage8 from "./pages/NewSignupPages/NewSignupPage8";
import NewSignupPage9 from "./pages/NewSignupPages/NewSignupPage9";
import IntakeFormPage1 from "./pages/IntakeFormPages/IntakeFormPage1";
import IntakeFormPage2 from "./pages/IntakeFormPages/IntakeFormPage2";
import IntakeFormPage3 from "./pages/IntakeFormPages/IntakeFormPage3";
import IntakeFormPage4 from "./pages/IntakeFormPages/IntakeFormPage4";
import IntakeFormPage5 from "./pages/IntakeFormPages/IntakeFormPage5";
import IntakeFormPage6 from "./pages/IntakeFormPages/IntakeFormPage6";
import IntakeFormPage7 from "./pages/IntakeFormPages/IntakeFormPage7";
import IntakeFormPage8 from "./pages/IntakeFormPages/IntakeFormPage8";
import IntakeFormPage9 from "./pages/IntakeFormPages/IntakeFormPage9";
import IntakeFormPage10 from "./pages/IntakeFormPages/IntakeFormPage10";
import IntakeFormPage11 from "./pages/IntakeFormPages/IntakeFormPage11";
import IntakeFormPage12 from "./pages/IntakeFormPages/IntakeFormPage12";
import IntakeFormPage13 from "./pages/IntakeFormPages/IntakeFormPage13";
import IntakeFormPage14 from "./pages/IntakeFormPages/IntakeFormPage14";
import IntakeFormPage15 from "./pages/IntakeFormPages/IntakeFormPage15";
import IntakeFormPage16 from "./pages/IntakeFormPages/IntakeFormPage16";
import IntakeFormPage17 from "./pages/IntakeFormPages/IntakeFormPage17";
import IntakeFormPage18 from "./pages/IntakeFormPages/IntakeFormPage18";
import NadPlusPage14 from "./pages/NadPlusPages/NadPlusPage14";
import DisqualifyStateNadPlusPage from "./pages/NadPlusPages/DisqualifyStateNadplusPage";
import CheckoutSignupPage4 from "./pages/CheckoutSignupPages/CheckoutSignupPage4";
import CheckoutSignupPage5 from "./pages/CheckoutSignupPages/CheckoutSignupPage5";
import CheckoutSignupPage6 from "./pages/CheckoutSignupPages/CheckoutSignupPage6";
import CheckoutSignupPage7 from "./pages/CheckoutSignupPages/CheckoutSignupPage7";
import CheckoutSignupPage8 from "./pages/CheckoutSignupPages/CheckoutSignupPage8";
import CheckoutSignupPage9 from "./pages/CheckoutSignupPages/CheckoutSignupPage9";
import CheckoutSignupPage10 from "./pages/CheckoutSignupPages/CheckoutSignupPage10";
import CheckoutSignupPage11 from "./pages/CheckoutSignupPages/CheckoutSignupPage11";
import CheckoutSignupPage3 from "./pages/CheckoutSignupPages/CheckoutSignupPage3";
import CheckoutSignupPage1 from "./pages/CheckoutSignupPages/CheckoutSignupPage1";
import CheckoutSignupPage2 from "./pages/CheckoutSignupPages/CheckoutSignupPage2";
import CheckoutSignupPage12 from "./pages/CheckoutSignupPages/CheckoutSignupPage12";
import NewFunnelStep1 from "./pages/NewFunnelStepPages/NewFunnelStep1";
import NewFunnelStep2 from "./pages/NewFunnelStepPages/NewFunnelStep2";
import NewFunnelStep3 from "./pages/NewFunnelStepPages/NewFunnelStep3";
import NewFunnelStep4 from "./pages/NewFunnelStepPages/NewFunnelStep4";
import NewFunnelStep5 from "./pages/NewFunnelStepPages/NewFunnelStep5";
import NewFunnelStep6 from "./pages/NewFunnelStepPages/NewFunnelStep6";
import NewFunnelStep7 from "./pages/NewFunnelStepPages/NewFunnelStep7";
import NewFunnelStep8 from "./pages/NewFunnelStepPages/NewFunnelStep8";
import NewFunnelStep9 from "./pages/NewFunnelStepPages/NewFunnelStep9";
import NewFunnelStep10 from "./pages/NewFunnelStepPages/NewFunnelStep10";
import NewFunnelStep11 from "./pages/NewFunnelStepPages/NewFunnelStep11";
import NewFunnelStep5A from "./pages/NewFunnelStepPages/NewFunnelStep5A";
import NewFunnelStep12 from "./pages/NewFunnelStepPages/NewFunnelStep12";
import NewFunnelStep13 from "./pages/NewFunnelStepPages/NewFunnelstep13";
import NewFunnelStep14 from "./pages/NewFunnelStepPages/NewFunnelStep14";
import NewFunnelStep15 from "./pages/NewFunnelStepPages/NewFunnelStep15";


const addFBTracking = () => {
  // if (document.getElementById("fb-pixel-script")) return;
  // const FB_PIXEL_ID = 620752890542636;
  // const script = document.createElement("script");
  // script.innerHTML = `
  //     !(function (f, b, e, v, n, t, s) {
  //       if (f.fbq) return;
  //       n = f.fbq = function () {
  //         n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  //       };
  //       if (!f._fbq) f._fbq = n;
  //       n.push = n;
  //       n.loaded = !0;
  //       n.version = "2.0";
  //       n.queue = [];
  //       t = b.createElement(e);
  //       t.async = !0;
  //       t.src = v;
  //       s = b.getElementsByTagName(e)[0];
  //       s.parentNode.insertBefore(t, s);
  //     })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  //     if(typeof fbq === 'undefined') {
  //       fbq("init", "${FB_PIXEL_ID}");
  //     }
  //     // fbq("track", "PageView");
  //   `;
  // document.head.appendChild(script);

  // // Insert noscript fallback (for users with JS disabled)
  // const noscript = document.createElement("noscript");
  // noscript.innerHTML = `<img height="1" width="1" style="display:none"
  //     src="https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1"/>`;
  // document.head.appendChild(noscript);
};

const isProd = process.env.REACT_APP_ENV === "production";
const GTM_ID = isProd ? "GTM-N292X5NG" : "GTM-WJV6WW4R" ;

console.log("env", process.env.REACT_APP_ENV);

const addGTMTracking = () => {
  // Check if GTM script already exists
  if (document.getElementById("gtm-script")) return;
  // const GTM_ID = "GTM-N292X5NG";

  // Insert GTM script dynamically
  const script = document.createElement("script");
  script.id = "gtm-script";
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');
  `;
  document.head.appendChild(script);
};
declare global {
  interface Window {
    dataLayer: any[];
  }
}
declare global {
  interface Window {
    EF?: {
      click: (params: {
        offer_id: string | null;
        affiliate_id?: string | null;
        sub1?: string | null;
        sub2?: string | null;
        sub3?: string | null;
        sub4?: string | null;
        sub5?: string | null;
        uid?: string | null;
        source_id?: string | null;
        transaction_id?: string | null;
      }) => void;
      conversion: (params: {
        offer_id: number;
        amount?: number;
        affiliate_id?: string;
      }) => void;
    };
    // fbq: (...args: any[]) => void;
  }
}

const addEverflowTracking = () => {
  if (document.getElementById("everflow-script")) return;

  const script = document.createElement("script");
  script.id = "everflow-script";
  script.src = "https://www.sffpl8trk.com/scripts/sdk/everflow.js";
  script.onload = () => {
    if (window.EF) {
      const urlParams = new URLSearchParams(window.location.search);
      const offerId = urlParams.get("o_id") ? urlParams.get("o_id") : "1";
      const affiliateId = urlParams.get("aff_id") ? urlParams.get("aff_id") : "17";

      window.EF.click({
        offer_id: offerId,
        affiliate_id: affiliateId,
        sub1: urlParams.get("sub1"),
        sub2: urlParams.get("sub2"),
        sub3: urlParams.get("sub3"),
        sub4: urlParams.get("sub4"),
        sub5: urlParams.get("sub5"),
        uid: urlParams.get("uid"),
        source_id: urlParams.get("source_id"),
        transaction_id: urlParams.get("_ef_transaction_id"),
      });
    }
  };
  document.head.appendChild(script);
};

const addTrackdeskTracking = () => {
  if (document.getElementById("trackdesk-script")) return;

  const script = document.createElement("script");
  script.id = "trackdesk-script";
  script.async = true;
  script.src = "//cdn.trackdesk.com/tracking.js";
  document.head.appendChild(script);

  (function (t: any, d: any, k: any) {
    (t[k] = t[k] || []).push(d);
    t[d] =
      t[d] ||
      t[k].f ||
      function () {
        (t[d].q = t[d].q || []).push(arguments);
      };
  })(window as any, "trackdesk", "TrackdeskObject");
};

const App: React.FC = () => {
  const [uuid, setUuid] = useState<string>("");

  useEffect(() => {
    const allValues: Record<string, any> = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        const value = localStorage.getItem(key);
        try {
          allValues[key] = JSON.parse(value || "");
        } catch {
          allValues[key] = value;
        }
      }
    }
  }, []);
  // Generate and set UUID on component load
  useEffect(() => {
    const storedUUID = localStorage.getItem("uuid");

    if (!storedUUID) {
      const newUUID = uuidv4();
      localStorage.setItem(
        "uuid",
        JSON.stringify({ key: "uuid", value: newUUID })
      );
      setUuid(newUUID);
    } else {
      setUuid(JSON.parse(storedUUID).value);
    }
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
  
    const tenantId = urlParams.get("tenantId");
    const linkId = urlParams.get("linkId");
    const sourceId = urlParams.get("sourceId");
  
    if (tenantId) localStorage.setItem("td_tenantId", tenantId);
    if (linkId) localStorage.setItem("td_linkId", linkId);
    if (sourceId) localStorage.setItem("td_sourceId", sourceId);
  
    addTrackdeskTracking(); // load once for whole SPA
  }, []);

  useEffect(() => {
    const getQueryParam = (name: string): string | null => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    };
  
    // Get current path to determine funnel type
    const pathname = window.location.pathname;
  
    // Defaults
    let defaultAffiliateId = "17";
    let defaultOfferId = "1";
  
    if (pathname.startsWith("/nadplus")) {
      defaultAffiliateId = "17"; //  NAD+ affiliate ID
      defaultOfferId = "5";     //  NAD+ offer ID
    } else if (pathname.startsWith("/sermorelin")) {
      defaultAffiliateId = "17"; //  Sermorelin affiliate ID
      defaultOfferId = "5";     //  Sermorelin offer ID
    } else {
      // Default for GLP-1
      defaultAffiliateId = "17";
      defaultOfferId = "1";
    }
  
    // Use query params if present; else fall back to funnel-specific defaults
    const affId = getQueryParam("aff_id") || defaultAffiliateId;
    const oId = getQueryParam("o_id") || defaultOfferId;
  
    localStorage.setItem("affiliate_id", affId);
    localStorage.setItem("offer_id", oId);
  
    // Tracking
    addGTMTracking();
    addEverflowTracking();
  }, [uuid]);

  // useEffect(() => {
  //   const getQueryParam = (name: string): string | null => {
  //     const urlParams = new URLSearchParams(window.location.search);
  //     return urlParams.get(name);
  //   };

  //   // Read 'aff_id' & 'o_id' from the URL
  //   const affId = getQueryParam("aff_id") ? getQueryParam("aff_id") : "17";
  //   const oId = getQueryParam("o_id") ? getQueryParam("o_id") : "1";

  //   if (affId) {
  //     localStorage.setItem("affiliate_id", affId);
  //   }
  //   if (oId) {
  //     localStorage.setItem("offer_id", oId);
  //   }
  //   // addFBTracking();
  //   addGTMTracking();
  //   addEverflowTracking();
  // }, [uuid]);

  useEffect(() => {
    // Store variant flag
    const urlParams = new URLSearchParams(window.location.search);
    // const isNewFunnel = urlParams.get("glid");
    const isNewFunnelVariant = urlParams.get("glid");
    const glid = urlParams.get("glid");
    // const isCheckoutFunnel = urlParams.get("glid");
    // if(isNewFunnel === "65ece789-375c-900a"){
    //   localStorage.setItem("isNewFunnel", "true");
    // }
    if(isNewFunnelVariant === "68ece789-675c-700a"){
      localStorage.setItem("isNewFunnelVariant", "true");
    }
    if (glid === "67ece619-450c-800a") {
      localStorage.setItem("isVariant", "true");
    }
      localStorage.setItem("isNewFunnel", "true");
  }, []);

  const isNewFunnel = localStorage.getItem("isNewFunnel") === "true";

  const isNewFunnelVariant = localStorage.getItem("isNewFunnelVariant") === "true";

  const isVariant = localStorage.getItem("isVariant") === "true";


  return (
    <QuizProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/sso-login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          {/* <Route path="/" element={<SignupPage2/>} /> */}
          {
            isNewFunnel || isNewFunnelVariant ? 
            <>
            <Route path="/getting-started/step-1" element={<NewSignupPage1 />} />
            <Route path="/getting-started/step-2" element={<NewSignupPage2 />} />
            <Route path="/getting-started/step-3" element={<NewSignupPage3 />} />
            <Route path="/getting-started/step-4" element={<NewSignupPage4 />} />
            <Route path="/getting-started/step-5" element={<NewSignupPage5 />} />
            <Route path="/getting-started/step-6" element={<NewSignupPage6 />} />
            <Route path="/getting-started/step-7" element={<NewSignupPage7 />} /> 
            {
              !isNewFunnelVariant &&  <Route path="/getting-started/step-8" element={<NewSignupPage8 />} />
            } 
            <Route path="/getting-started/step-9" element={<NewSignupPage9 />} />
            </>
            :
            <>
            <Route path="/getting-started/step-1" element={<SignupPage4 />} />
          <Route path="/getting-started/step-2" element={<SignupPage5 />} />
          <Route path="/getting-started/step-3" element={<SignupPage6New />} />
          <Route path="/getting-started/step-4" element={<SignupPage7 />} />
          <Route path="/getting-started/step-5" element={<SignupPage9 />} />
          <Route path="/getting-started/step-6" element={<SignupPage10 />} />
          <Route path="/getting-started/step-6b" element={<SignupPage10New/>}/>
          <Route path="/getting-started/step-7" element={<SignupPage11 />} />
          <Route path="/getting-started/step-8" element={<SignupPage13 />} />
          <Route path="/getting-started/step-9" element={<SignupPage14 />} />
          {!isVariant && (
            <>
              <Route path="/getting-started/step-10" element={<SignupPage15 />} />
              <Route path="/getting-started/step-11" element={<SignupPage16 />} />
            </>
          )}
          <Route path="/getting-started/step-12" element={<SignupPage17 />} />
          <Route path="/getting-started/step-13" element={<SignupPage18New />} />
          <Route path="/getting-started/step-13b"element={<SignupPage19 />} />
            </>
          }
          
          <Route path="/getting-started/step-14" element={<SignupPage25 />} />
          <Route path="/getting-started/step-15" element={<SignupPage26 />} />
          <Route path="/getting-started/step-16" element={<SignupPage22 />} />

          <Route path="/getting-started/step-17" element={<SignupPage23 />} />
          <Route path="/getting-started/step-18" element={<SignupPage24 />} />

          <Route path="/getting-started/invalid-age" element={<InvalidAge />} />
          <Route path="/getting-started/disqualified" element={<DisqualifiedPage/>}/>
          <Route path="*" element={<NotFound />} />

          <Route path="/glp1/checkout" element={<CheckoutSignupPage1 />} />
          <Route path="/glp1/checkout/payment" element={<CheckoutSignupPage2 />} />
          <Route path="/glp1/thank-you" element={<CheckoutSignupPage3 />} /> 
          <Route path="/glp1/getting-started/step-1" element={<CheckoutSignupPage4 />} />
          <Route path="/glp1/getting-started/step-2" element={<CheckoutSignupPage5 />} />
          <Route path="/glp1/getting-started/step-3" element={<CheckoutSignupPage6 />} />
          <Route path="/glp1/getting-started/step-4" element={<CheckoutSignupPage7 />} />
          <Route path="/glp1/getting-started/step-5" element={<CheckoutSignupPage8 />} />
          <Route path="/glp1/getting-started/step-6" element={<CheckoutSignupPage9 />} />
          <Route path="/glp1/getting-started/step-7" element={<CheckoutSignupPage10 />} />
          <Route path="/glp1/getting-started/step-8" element={<CheckoutSignupPage11 />} />
          <Route path="/glp1/getting-started/thank-you" element={<CheckoutSignupPage12 />}/> 

          <Route path="/" element={<NewFunnelStep1/>}/>
          <Route path="/glp1/intake-form/step-1" element={<NewFunnelStep2/>}/>
          <Route path="/glp1/intake-form/step-2" element={<NewFunnelStep3/>}/>
          <Route path="/glp1/intake-form/step-3" element={<NewFunnelStep4/>}/>
          <Route path="/glp1/intake-form/step-4" element={<NewFunnelStep5/>}/>
          <Route path="/glp1/intake-form/step-4a" element={<NewFunnelStep5A/>}/>
          <Route path="/glp1/intake-form/step-5" element={<NewFunnelStep6/>}/>
          <Route path="/glp1/intake-form/step-6" element={<NewFunnelStep7/>}/>
          <Route path="/glp1/intake-form/step-7" element={<NewFunnelStep8/>}/>
          <Route path="/glp1/intake-form/step-8" element={<NewFunnelStep9/>}/>
          <Route path="/glp1/intake-form/step-9" element={<NewFunnelStep10/>}/>
          <Route path="/glp1/intake-form/step-10" element={<NewFunnelStep11/>}/>
          <Route path="/glp1/intake-form/step-11" element={<NewFunnelStep12/>}/>
          <Route path="/glp1/intake-form/disqualified" element={<NewFunnelStep13/>}/>
          <Route path="/glp1/intake-form/step-12" element={<NewFunnelStep14/>}/>
          <Route path="/glp1/intake-form/thank-you" element={<NewFunnelStep15/>}/>

          <Route path="/nadplus" element={<NadPlusPage/>}/>
          <Route path="/nadplus/getting-started/step-1" element={<NadPlusPage1/>}/>
          <Route path="/nadplus/getting-started/step-2" element={<NadPlusPage2/>}/>
          <Route path="/nadplus/getting-started/step-3" element={<NadPlusPage3/>}/>
          <Route path="/nadplus/getting-started/step-4" element={<NadPlusPage4/>}/>
          <Route path="/nadplus/getting-started/step-5" element={<NadPlusPage5/>}/>
          <Route path="/nadplus/getting-started/step-6" element={<NadPlusPage6/>}/>
          <Route path="/nadplus/getting-started/step-7" element={<NadPlusPage7/>}/>
          <Route path="/nadplus/getting-started/step-8" element={<NadPlusPage8/>}/>
          <Route path="/nadplus/getting-started/step-9" element={<NadPlusPage9/>}/>
          <Route path="/nadplus/getting-started/step-10" element={<NadPlusPage10/>}/>
          <Route path="/nadplus/getting-started/step-11" element={<NadPlusPage11/>}/>
          <Route path="/nadplus/getting-started/step-12" element={<NadPlusPage12/>}/>
          <Route path="/nadplus/getting-started/step-13" element={<NadPlusPage13/>}/>
          <Route path="/nadplus/getting-started/step-14" element={<NadPlusPage14/>}/>
          <Route path="/nadplus/thank-you" element={<NadPlusThankYouPage />}/>
          <Route path="/nadplus/disqualified-by-state" element={<DisqualifyStateNadPlusPage/>}/>
          <Route path="/nadplus/disqualified" element={<DisqualifyNadPlusPage/>}/>

          <Route path="/sermorelin" element={<SermorelinPage/>}/>
          <Route path="/sermorelin/getting-started/step-1" element={<NadPlusPage1/>}/>
          <Route path="/sermorelin/getting-started/step-2" element={<NadPlusPage2/>}/>
          <Route path="/sermorelin/getting-started/step-3" element={<NadPlusPage3/>}/>
          <Route path="/sermorelin/getting-started/step-4" element={<NadPlusPage4/>}/>
          <Route path="/sermorelin/getting-started/step-5" element={<NadPlusPage5/>}/>
          <Route path="/sermorelin/getting-started/step-6" element={<NadPlusPage6/>}/>
          <Route path="/sermorelin/getting-started/step-7" element={<NadPlusPage7/>}/>
          <Route path="/sermorelin/getting-started/step-8" element={<SermorelinPage8/>}/>
          <Route path="/sermorelin/getting-started/step-9" element={<SermorelinPage9/>}/>
          <Route path="/sermorelin/getting-started/step-10" element={<SermorelinPage10/>}/>
          <Route path="/sermorelin/getting-started/step-11" element={<NadPlusPage8/>}/>
          <Route path="/sermorelin/getting-started/step-12" element={<NadPlusPage9/>}/>
          <Route path="/sermorelin/getting-started/step-13" element={<NadPlusPage10/>}/>
          <Route path="/sermorelin/getting-started/step-14" element={<SermorelinPage14/>}/>
          <Route path="/sermorelin/getting-started/step-15" element={<NadPlusPage14/>}/>
          <Route path="/sermorelin/thank-you" element={<NadPlusThankYouPage />}/>
          <Route path="/sermorelin/disqualified" element={<DisqualifyNadPlusPage/>}/>

          <Route path="/email-check" element={<IntakeFormPage1/>}/>
          <Route path="/email-check1" element={<IntakeFormPage2/>}/>
          <Route path="/complete-intake/step-1" element={<IntakeFormPage3/>}/>
          <Route path="/complete-intake/step-2" element={<IntakeFormPage4/>}/>
          <Route path="/complete-intake/step-3" element={<IntakeFormPage5/>}/>
          <Route path="/complete-intake/step-4" element={<IntakeFormPage6/>}/>
          <Route path="/complete-intake/step-5" element={<IntakeFormPage7/>}/>
          <Route path="/complete-intake/step-6" element={<IntakeFormPage8/>}/>
          <Route path="/complete-intake/step-6b" element={<IntakeFormPage9/>}/>
          <Route path="/complete-intake/step-7" element={<IntakeFormPage10/>}/>
          <Route path="/complete-intake/step-8" element={<IntakeFormPage11/>}/>
          <Route path="/complete-intake/step-9" element={<IntakeFormPage12/>}/>
          <Route path="/complete-intake/step-10" element={<IntakeFormPage13/>}/>
          <Route path="/complete-intake/step-11" element={<IntakeFormPage14/>}/>
          <Route path="/complete-intake/step-12" element={<IntakeFormPage15/>}/>
          <Route path="/complete-intake/step-13" element={<IntakeFormPage16/>}/>
          <Route path="/complete-intake/thank-you" element={<IntakeFormPage17/>}/>
          <Route path="/email-check2" element={<IntakeFormPage18/>}/>
          <Route path="/complete-intake/disqualified" element={<DisqualifiedPage/>}/>
          
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/account" element={<Dashboard />} />
          <Route
            path="/dashboard/schedule_consultation"
            element={<Dashboard />}
          />
          <Route path="/supplement-checkout" element={<SupplementCheckout/>}/>
          <Route path="/supplement-checkout/thank-you" element={<ThankYouPage />}/>
          <Route path="/dashboard/book_appointment" element={<Dashboard />} />
          <Route path="/dashboard/appointment_booked" element={<Dashboard />} />
        </Routes>
      </Router>
    </QuizProvider>
  );
};

export default App;
